import { Component, Input, ViewEncapsulation, HostBinding } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../../animations/page-transitions';

@Component({
	selector: 'copo-coil-calculator-widget',
	templateUrl: './coil-calculator-widget.component.html',
	styleUrl: './coil-calculator-widget.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,

	imports: [TranslateModule, MatButtonModule, RouterLink, MatIconModule]
})
export class CoilCalculatorWidgetComponent {
	@HostBinding('class.services-box') box = true;
	@Input() headerLabel!: string;
	@Input() btnLabel!: string;
	@Input() btnRouterLink!: string;
}
